import { isInvalid } from "./forms";
import TrashIcon from "../components/icon/TrashIcon";
import TramiteIcon from "../components/icon/TramiteIcon";
import PencilIcon from "../components/icon/PencilIcon";
import AsteriskIcon from "../components/icon/AsteriskIcon";
import { EstadoTramite, TipoTramite } from "./enums";

export const ACCIONES_TRAMITE = {
  crear: "iniciar",
  eliminar: "eliminar",
  editar: "continuar",
  ver: "visualizar",
};

export function isEditable(tramite) {
  return (
    [EstadoTramite.PENDIENTE, EstadoTramite.INICIADO].indexOf(
      tramite?.estado?.codigo,
    ) >= 0
  );
}

export function isFinalizado(tramite) {
  return tramite?.estado?.codigo === EstadoTramite.FINALIZADO;
}

export function isPresentado(tramite) {
  return tramite?.estado?.codigo === EstadoTramite.PRESENTADO;
}

export function isProcesado(tramite) {
  return tramite?.estado?.codigo === EstadoTramite.APROBADO;
}

function isCargando(tramite) {
  return (
    [
      EstadoTramite.INICIADO,
      EstadoTramite.PENDIENTE,
      EstadoTramite.FINALIZADO,
    ].indexOf(tramite?.estado?.codigo) >= 0
  );
}
function puedeCrear(tipo, establecimiento, ultimoTramite, tramitesPorTipo) {
  switch (tipo.codigo) {
    case TipoTramite.DJE:
      return false;
    case TipoTramite.DJG:
      return (
        (!ultimoTramite || isProcesado(ultimoTramite)) &&
        (!tramitesPorTipo[TipoTramite.DJE] ||
          isProcesado(tramitesPorTipo[TipoTramite.DJE])) &&
        !isCargando(tramitesPorTipo[TipoTramite.DJA]) &&
        !isPresentado(tramitesPorTipo[TipoTramite.DJA]) &&
        !isCargando(tramitesPorTipo[TipoTramite.DJEELL]) &&
        !isPresentado(TipoTramite.DJEELL) &&
        !isCargando(tramitesPorTipo[TipoTramite.DJRR]) &&
        !isPresentado(tramitesPorTipo[TipoTramite.DJRR]) &&
        !isCargando(
          tramitesPorTipo[TipoTramite.DJEEGG] &&
            !isPresentado(tramitesPorTipo[TipoTramite.DJEEGG]),
        )
      );
    case TipoTramite.DJA:
      return (
        (!ultimoTramite || isProcesado(ultimoTramite)) &&
        !isCargando(tramitesPorTipo[TipoTramite.DJE]) &&
        !isCargando(tramitesPorTipo[TipoTramite.DJG]) &&
        !isPresentado(tramitesPorTipo[TipoTramite.DJG]) &&
        establecimiento.estaEmpadronado
      );
    case TipoTramite.DJEELL:
      return (
        (!ultimoTramite || isProcesado(ultimoTramite)) &&
        !isCargando(tramitesPorTipo[TipoTramite.DJE]) &&
        !isCargando(tramitesPorTipo[TipoTramite.DJG]) &&
        !isPresentado(tramitesPorTipo[TipoTramite.DJG]) &&
        establecimiento.conEfluentesLiquidos &&
        establecimiento.estaEmpadronado
      );
    case TipoTramite.DJRR:
      return (
        (!ultimoTramite || isProcesado(ultimoTramite)) &&
        !isCargando(tramitesPorTipo[TipoTramite.DJE]) &&
        !isCargando(tramitesPorTipo[TipoTramite.DJG]) &&
        !isPresentado(tramitesPorTipo[TipoTramite.DJG]) &&
        (establecimiento.conResiduosPatogenico ||
          establecimiento.conResiduosPeligrosos ||
          establecimiento.conResiduosSolidosUrbanos ||
          establecimiento.conEquiposPCB) &&
        establecimiento.estaEmpadronado
      );
    case TipoTramite.DJEEGG:
      return (
        (!ultimoTramite || isProcesado(ultimoTramite)) &&
        !isCargando(tramitesPorTipo[TipoTramite.DJE]) &&
        !isCargando(tramitesPorTipo[TipoTramite.DJG]) &&
        !isPresentado(tramitesPorTipo[TipoTramite.DJG]) &&
        establecimiento.conEmisionesGaseosas &&
        establecimiento.estaEmpadronado
      );
    default:
      return false;
  }
}

function puedeEditar(tipo, establecimiento, ultimoTramite, tramitesPorTipo) {
  return tipo.codigo === TipoTramite.DJE ? false : isCargando(ultimoTramite);
}

function puedeEliminar(tipo, establecimiento, ultimoTramite, tramitesPorTipo) {
  return tipo.codigo === TipoTramite.DJE ? false : isCargando(ultimoTramite);
}

function puedeVer(tipo, establecimiento, ultimoTramite, tramitesPorTipo) {
  return isPresentado(ultimoTramite);
}

export function listarAcciones(
  tipo,
  establecimiento,
  ultimoTramite,
  tramitesPorTipo,
) {
  if (!establecimiento) return [];
  const acciones = [];
  if (puedeCrear(tipo, establecimiento, ultimoTramite, tramitesPorTipo)) {
    acciones.push({
      name: ACCIONES_TRAMITE.crear,
      variant: "success",
      icon: <AsteriskIcon />,
    });
  } else {
    acciones.push({
      name: ACCIONES_TRAMITE.crear,
      disabled: true,
      icon: <AsteriskIcon />,
    });
  }
  if (puedeEditar(tipo, establecimiento, ultimoTramite, tramitesPorTipo)) {
    acciones.push({
      name: ACCIONES_TRAMITE.editar,
      variant: "primary",
      icon: <PencilIcon />,
    });
  } else {
    acciones.push({
      name: ACCIONES_TRAMITE.editar,
      disabled: true,
      icon: <PencilIcon />,
    });
  }
  if (puedeEliminar(tipo, establecimiento, ultimoTramite, tramitesPorTipo)) {
    acciones.push({
      name: ACCIONES_TRAMITE.eliminar,
      variant: "danger",
      icon: <TrashIcon />,
    });
  } else {
    acciones.push({
      name: ACCIONES_TRAMITE.eliminar,
      disabled: true,
      icon: <TrashIcon />,
    });
  }
  if (puedeVer(tipo, establecimiento, ultimoTramite, tramitesPorTipo)) {
    acciones.push({
      name: ACCIONES_TRAMITE.ver,
      variant: "primary",
      icon: <TramiteIcon />,
    });
  } else {
    acciones.push({
      name: ACCIONES_TRAMITE.ver,
      disabled: true,
      icon: <TramiteIcon />,
    });
  }
  return acciones;
}

export const MesesProduccion = [
  "ENERO",
  "FEBRERO",
  "MARZO",
  "ABRIL",
  "MAYO",
  "JUNIO",
  "JULIO",
  "AGOSTO",
  "SEPTIEMBRE",
  "OCTUBRE",
  "NOVIEMBRE",
  "DICIEMBRE",
];

export const DIAS_SEMANA = [
  "LUNES",
  "MARTES",
  "MIERCOLES",
  "JUEVES",
  "VIERNES",
  "SABADO",
  "DOMINGO",
];

export function isEmpresaFormInvalid(tramiteForm) {
  return isInvalid("empresa", tramiteForm);
}

export function isEstablecimientoFormInvalid(tramiteForm) {
  return (
    isInvalid("domicilio", tramiteForm) ||
    isInvalid("ubicacion", tramiteForm) ||
    isInvalid("zonaEmplazamiento", tramiteForm) ||
    isInvalid("accesoSecundario", tramiteForm) ||
    isInvalid("habilitacionMunicipal", tramiteForm) ||
    isInvalid("telefono", tramiteForm) ||
    isInvalid("correoElectronico", tramiteForm) ||
    isInvalid("web", tramiteForm)
  );
}

export function isActividadFormInvalid(tramiteForm) {
  return (
    isInvalid("actividadPrincipal", tramiteForm) ||
    isInvalid("actividadSecundaria", tramiteForm) ||
    isInvalid("descripcionActividad", tramiteForm)
  );
}

export function isRepresentanteLegalFormInvalid(tramiteForm) {
  return isInvalid("representanteLegal", tramiteForm);
}

export function isRepresentanteTecnicoFormInvalid(tramiteForm) {
  return isInvalid("representanteTecnico", tramiteForm);
}

export function isImpactoAmbientalFormInvalid(tramiteForm) {
  return (
    isInvalid("conEfluentesLiquidos", tramiteForm) ||
    isInvalid("conResiduosSolidosUrbanos", tramiteForm) ||
    isInvalid("conResiduosPeligrosos", tramiteForm) ||
    isInvalid("conResiduosPatogenicos", tramiteForm) ||
    isInvalid("conEmisionesGaseosas", tramiteForm) ||
    isInvalid("categoriaAmbiental", tramiteForm) ||
    isInvalid("nivelComplejidadAmbiental", tramiteForm) ||
    isInvalid("conCertificadoAptitudAmbiental", tramiteForm) ||
    isInvalid("conTramiteCertificadoAptitudAmbiental", tramiteForm) ||
    isInvalid("certificadoAptitudAmbiental", tramiteForm) ||
    isInvalid("conCertificadoISO14001", tramiteForm) ||
    isInvalid("conSeguroAmbiental", tramiteForm) ||
    isInvalid("seguroAmbiental", tramiteForm) ||
    isInvalid("conRiesgoExplosion", tramiteForm) ||
    isInvalid("conRiesgoIncendio", tramiteForm) ||
    isInvalid("conRiesgoRuidos", tramiteForm) ||
    isInvalid("conRiesgoSustanciasQuimicas", tramiteForm) ||
    isInvalid("conSitiosContaminados", tramiteForm) ||
    isInvalid("conFreatimetros", tramiteForm) ||
    isInvalid("conRemediacionesActivas", tramiteForm) ||
    isInvalid("remediaciones", tramiteForm)
  );
}

export function isOperacionesUnitariasFormInvalid(tramiteForm) {
  return isInvalid("operacionesUnitarias", tramiteForm);
}

export function isProduccionFormInvalid(tramiteForm) {
  return (
    isInvalid("conEstacionalidad", tramiteForm) ||
    isInvalid("mesesProduccion", tramiteForm) ||
    isInvalid("procesoProductivo", tramiteForm) ||
    isInvalid("productosElaborados", tramiteForm)
  );
}

export function isSustanciasQuimicasFormInvalid(tramiteForm) {
  return (
    isInvalid("conQuimicosAuxiliares", tramiteForm) ||
    isInvalid("conQuimicosProduccion", tramiteForm) ||
    isInvalid("sustanciasQuimicas", tramiteForm)
  );
}

export function isRegimenLaboralFormInvalid(tramiteForm) {
  return (
    isInvalid("personal", tramiteForm) ||
    isInvalid("regimenLaboral", tramiteForm)
  );
}

export function isInfraestructuraFormInvalid(tramiteForm) {
  return (
    isInvalid("superficieTotal", tramiteForm) ||
    isInvalid("superficieProduccion", tramiteForm) ||
    isInvalid("conConexionCloacas", tramiteForm) ||
    isInvalid("conPozoAbsorbente", tramiteForm) ||
    isInvalid("potenciaActiva", tramiteForm) ||
    isInvalid("consumoElectricidad", tramiteForm) ||
    isInvalid("consumoGasNatural", tramiteForm) ||
    isInvalid("conEnergiaAlternativa", tramiteForm) ||
    isInvalid("fuenteEnergiaAlternativa", tramiteForm) ||
    isInvalid("consumoEnergiaAlternativa", tramiteForm) ||
    isInvalid("conCaptacionAguaRed", tramiteForm) ||
    isInvalid("conCaptacionAguaSubterranea", tramiteForm) ||
    isInvalid("conCaptacionAguaSuperficial", tramiteForm) ||
    isInvalid("conAprovechamientoPluviales", tramiteForm) ||
    isInvalid("conReusoAgua", tramiteForm) ||
    isInvalid("conexionRedAgua", tramiteForm) ||
    isInvalid("pozosAguaSubterranea", tramiteForm) ||
    isInvalid("tomasAguaSuperficial", tramiteForm) ||
    isInvalid("aprovechamientoPluviales", tramiteForm) ||
    isInvalid("reusoAgua", tramiteForm)
  );
}

export function isOrigenEfluentesFormInvalid(tramiteForm) {
  return isInvalid("fuentesEfluentesLiquidos", tramiteForm);
}

export function isTratamientoEfluentesFormInvalid(tramiteForm) {
  return (
    isInvalid("plantasTratamiento", tramiteForm) ||
    isInvalid("tratamientoIndividual", tramiteForm)
  );
}

export function isEfluenteCrudoFormInvalid(tramiteForm) {
  return isInvalid("caracterizacionEfluenteCrudo", tramiteForm);
}

export function isDestinoEfluentesFormInvalid(tramiteForm) {
  return (
    isInvalid("lineasVertido", tramiteForm) ||
    isInvalid("conTratamientoExterno", tramiteForm) ||
    isInvalid("reusoTratamiento", tramiteForm)
  );
}

export function isTratamientoExternoFormInvalid(tramiteForm) {
  return isInvalid("tratamientosExternos", tramiteForm);
}

export function isResiduosTratamientoFormInvalid(tramiteForm) {
  return isInvalid("residuosTratamiento", tramiteForm);
}

export function isResiduosSolidosUrbanosFormInvalid(tramiteForm) {
  return (
    isInvalid("conTratamientoRSUInterno", tramiteForm) ||
    isInvalid("tratamientosRSU", tramiteForm) ||
    isInvalid("esGeneradorRSUEspeciales", tramiteForm) ||
    isInvalid("registroRSUEspeciales", tramiteForm) ||
    isInvalid("disponeRSUCEAMSE", tramiteForm) ||
    isInvalid("registroAltaCEAMSE", tramiteForm) ||
    isInvalid("disposicionRSU", tramiteForm) ||
    isInvalid("disposicionCertificadosRSU", tramiteForm) ||
    isInvalid("residuosSolidosUrbanos", tramiteForm)
  );
}

export function isResiduosPeligrososFormInvalid(tramiteForm) {
  return (
    isInvalid("registroResiduosPeligrosos", tramiteForm) ||
    isInvalid("residuosPeligrosos", tramiteForm)
  );
}

export function isResiduosPatogenicosFormInvalid(tramiteForm) {
  return (
    isInvalid("registroResiduosPatogenicos", tramiteForm) ||
    isInvalid("residuosPatogenicos", tramiteForm)
  );
}

export function isTransformadoresPCBFormInvalid(tramiteForm) {
  return (
    isInvalid("registroEquiposPCB", tramiteForm) ||
    isInvalid("conCertificadoLibrePCB", tramiteForm)
  );
}

export function isEmisionesGaseosasFormInvalid(tramiteForm) {
  return (
    isInvalid("conRegistroEmisionesGaseosas", tramiteForm) ||
    isInvalid("registroEmisionesGaseosas", tramiteForm) ||
    isInvalid("conMonitoreoAire", tramiteForm) ||
    isInvalid("monitoreoAire", tramiteForm)
  );
}

export function isFuentesFijasFormInvalid(tramiteForm) {
  return isInvalid("chimeneas", tramiteForm);
}

export function isAcopioLiquidosFormInvalid(tramiteForm) {
  return (
    isInvalid("conEvaporacionLiquidos", tramiteForm) ||
    isInvalid("conMovimientoLiquidos", tramiteForm) ||
    isInvalid("conAcopioLiquidos", tramiteForm) ||
    isInvalid("tanquesAcopioLiquidos", tramiteForm)
  );
}

export function isAcopioSolidosFormInvalid(tramiteForm) {
  return (
    isInvalid("conSolidosGranulares", tramiteForm) ||
    isInvalid("conSublimacionSolidos", tramiteForm) ||
    isInvalid("conAcopioSolidosGranel", tramiteForm) ||
    isInvalid("conAcopioSolidos1000m2", tramiteForm) ||
    isInvalid("areasAcopioSolidos", tramiteForm)
  );
}

export function isInvalidAdjuntosForm(tramiteForm) {
  return isInvalid("adjuntos", tramiteForm);
}

export function ordenarTiposTramite(tiposTramites) {
  return tiposTramites.sort((a, b) => {
    if (a.codigo === b.codigo) return 0;
    switch (a.codigo) {
      case TipoTramite.DJE:
        return -1;
      case TipoTramite.DJG:
        if (b.codigo === TipoTramite.DJE) {
          return 1;
        } else {
          return -1;
        }
      case TipoTramite.DJA:
        if ([TipoTramite.DJE, TipoTramite.DJG].indexOf(b.codigo) >= 0) {
          return 1;
        } else {
          return -1;
        }
      case TipoTramite.DJEELL:
        if (
          [TipoTramite.DJE, TipoTramite.DJG, TipoTramite.DJA].indexOf(
            b.codigo,
          ) >= 0
        ) {
          return 1;
        } else {
          return -1;
        }
      case TipoTramite.DJRR:
        if (
          [
            TipoTramite.DJE,
            TipoTramite.DJG,
            TipoTramite.DJA,
            TipoTramite.DJEELL,
          ].indexOf(b.codigo) >= 0
        ) {
          return 1;
        } else {
          return -1;
        }
      case TipoTramite.DJEEGG:
        if (
          [
            TipoTramite.DJE,
            TipoTramite.DJG,
            TipoTramite.DJA,
            TipoTramite.DJEELL,
            TipoTramite.DJRR,
          ].indexOf(b.codigo) >= 0
        ) {
          return 1;
        } else {
          return -1;
        }
      default:
        return 0;
    }
  });
}
